import { Colors } from "../../../palettes/colorPalette";

export default () => {
	return `
struct LightingInfo {
	vec3 ambientColor;
	vec3 diffuseColor;
	vec3 specularColor;
	vec3 litColor;
	float diffuseLight;
	float specularLight;
};

float ambientScaler = float(${Colors.AmbientScaler});
float diffuseScaler = float(${Colors.DiffuseScaler});
float rimScaler = float(${Colors.RimScaler});
float rimPower = float(${Colors.RimPower});
float specularScaler = float(${Colors.SpecularScaler});
float specularPower = float(${Colors.SpecularPower}); 

LightingInfo phongLighting(vec2 worldUv, vec3 normal, vec3 lightPosition, vec4 color) {
	//Ambient lighting
	vec3 ambientColor = vec3( ambientScaler );

	//Light setup
	vec3 worldPosition = vec3(worldUv.x, worldUv.y, 0.0);
	vec3 lightDirection = normalize(lightPosition - worldPosition);
	vec3 cameraPos = vec3(worldPosition.x, worldPosition.y, -10.0);
	vec3 viewDir = normalize(worldPosition - cameraPos);

	//Diffuse lighting
	float diffuseLight = max(dot(normal, lightDirection), 0.0);
	vec3 diffuseColor = vec3( vec3(diffuseScaler) * diffuseLight);

	//Rim light
	float rim = 1.0 - max(dot(viewDir, normal), 0.0);
	rim = pow(rim, rimPower);
	vec3 rimColor = rimScaler * vec3(rim);

	//Specular lighting
	
	vec3 reflectDir = reflect(-lightDirection, normal);
	float spec = pow(max(dot(viewDir, reflectDir), 0.0), specularPower);
	vec3 specularColor = specularScaler * spec * color.xyz;  

	//Regular Phong lighting
	vec3 litColor = color.xyz * (diffuseColor + ambientColor + specularColor + rimColor);
	litColor = litColor;

	//Tests
	//return normal.xyz; 
	//return color.xyz; 

	return LightingInfo(ambientColor, diffuseColor, specularColor, litColor, diffuseLight, spec);
}
`};